













import { RequisitionStatus, RequisitionStatusEnum } from '@/models/requisition';

import Vue from 'vue';
export default Vue.extend({
  name: 'RequisitionStatusDisplay',

  props: {
    status: { type: RequisitionStatus, required: true }
  },

  methods: {
    getStatusColor(): string {
      return this.status.getColor();
    },

    getStatusMessage(): string {
      switch (this.status.value) {
        case RequisitionStatusEnum.Draft:
          return 'Draft';

        case RequisitionStatusEnum.Submitted:
          return 'Submitted';

        case RequisitionStatusEnum.InReview:
          return 'Review In Progress';

        case RequisitionStatusEnum.Approval2Pending:
          return 'Approval II Pending';

        case RequisitionStatusEnum.Approval3Pending:
          return 'Approval III Pending';

        case RequisitionStatusEnum.Approval4Pending:
          return 'Approval IV Pending';

        case RequisitionStatusEnum.Approved:
          return 'Approved';

        case RequisitionStatusEnum.Rejected:
          return 'Rejected';

        case RequisitionStatusEnum.BuyerAssigned:
          return 'Buyer Assigned';

        case RequisitionStatusEnum.PurchaseInProgress:
          return 'Purchase In Progress';

        case RequisitionStatusEnum.PurchaseDelivered:
          return 'Purchase Complete';

        case RequisitionStatusEnum.Cancelled:
          return 'Cancelled';

        case RequisitionStatusEnum.Received:
          return 'Received';

        default:
          return (this.status as RequisitionStatus).display_name;
      }
    }
  }
});
